import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { delay, filter, map } from 'rxjs/operators';
import { CREATE_SUBSCRIPTION_SUCCESS } from '../actions';
import { CreateSubscriptionSuccess } from '../action-creators';
import { OpenMenu } from '../../ui/action-creators';

export const showSuccessMenuAfterCreatedEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CreateSubscriptionSuccess>(CREATE_SUBSCRIPTION_SUCCESS),
    filter((action) => action.newSubscription.key === 'trac_pro'),
    delay(5000),
    map(() => {
      return new OpenMenu('SUCCESS_SUBSCRIPTION_DIST_PRO');
    })
  );
